import styled from "styled-components";
import { IThemeProps } from 'component/theme';
import { Grid } from "@mui/material";
import "../../../styles/scss/mixin.scss"; 

export const StyledFlagHelpful = styled('div')`
    ${({theme}: IThemeProps)=> `
    padding: ${theme.uptimeSpace[8]}px ${theme.uptimeSpace[0]};
    margin-top: 48px !important;
    background: rgba(0, 0, 0, 0.06);
    border: none;
    border-radius: 12px;
    display: flex;
    min-height: 80px;
    align-items: center;
    .flag-icon {
        font-family: '${theme.uptimeFonts.primary}'${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`} !important;
    }
    .MuiFormGroup-root {
        display: inline;
    }
    .MuiFormControlLabel-root {
        margin-left: ${theme.uptimeSpace[0]};
        display: inline-block;
        > span {
            padding: ${theme.uptimeSpace[0]};
        }
    }
    .uptime-typography {
        font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
        line-height: ${theme.uptimeLineHeights.desktop.lh4}px;
        color: ${theme.uptimeColors.textColors.primary};
        font-family: '${theme.uptimeFonts.primary}'${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`} !important;
        display: block;
        text-align: center;
    }
    .flag-icon-list {
        .flag-icon {
            text-transform: unset;
            line-height: normal;
            padding: ${theme.uptimeSpace[0]};
            min-width: 40px;
        span {
            font-size: ${theme.uptimeFontSizes.desktop.fz2}px;
            line-height: ${theme.uptimeLineHeights.desktop.lh3}px;
            color: ${theme.uptimeColors.textColors.primary};
            font-style: normal;
            font-weight: 600;
            display: flex;
            align-items: center;
        }
        }
    }
    .icon-yes {
        .flag-like-icon {
            span{
                color: ${theme.uptimeColors.mainTheme.primary} !important;
            }
        }
        &.icon-disabled {
            opacity: 0.5;
            .flag-icon.Mui-disabled {
                color: ${theme.uptimeColors.textColors.primary};
            }
        }
    }
    .icon-no {
        .flag-dislike-icon {
            span{
                color: ${theme.uptimeColors.mainTheme.primary} !important;
            }
        }
        &.icon-disabled {
            opacity: 0.5;
            .flag-icon.Mui-disabled {
                color: ${theme.uptimeColors.textColors.primary};
            }
        }
    }     
    `}
`

export const StyledFlagHelpfulContainer = styled(Grid)`
    ${({theme}: IThemeProps) => `
        flex-wrap: wrap !important;
        @media (min-width: ${theme.breakpoints.sm}) {
            flex-wrap: nowrap !important;
        }
    `}
`;

export const StyledFlagIconList = styled('div')`
    ${({theme}: IThemeProps)=> `
        display: flex;
        gap: ${theme.uptimeSpace[5]}px;
        padding-left: ${theme.uptimeSpace[8]}px;
        .flag-icon {
            text-transform: unset;
            line-height: normal;
            padding: 0;
            min-width: 40px;
            display: flex;
            flex-direction: row;
            span {
                font-size: ${theme.uptimeFontSizes.desktop.fz2}px;
                line-height: ${theme.uptimeLineHeights.desktop.lh3}px;
                color: ${theme.uptimeColors.textColors.primary};
                font-style: normal;
                font-weight: 600;
                display: flex;
                align-items: center;
                padding: 0 ${theme.uptimeSpace[3]}px;
                text-decoration: none;
            }
        }
        &.icon-disabled {
            opacity: 0.5;
            .flag-icon.Mui-disabled {
                color: ${theme.uptimeColors.textColors.primary};
            }
        }
        .flag-like-icon,
        .flag-dislike-icon {
            svg {
                color: ${theme.uptimeColors.generalColors.icon.enabled} !important;
            }
        }
    `}
`;

export const StyledMessage = styled(Grid)`
    ${({theme}: IThemeProps) => `
        display: flex;
        align-items: center;
        font-size: ${theme.uptimeFontSizes.desktop.fz7}px;
        .MuiGrid-item {
            display: flex;
        }
        #hideMe {
            -webkit-animation: cssAnimation 5s forwards;
            animation: cssAnimation 5s forwards;
            font-size: ${theme.uptimeFontSizes.desktop.fz2}px;
            line-height: ${theme.uptimeLineHeights.desktop.lh3}px;
            text-align: right;
            color: ${theme.uptimeColors.textColors.primary};
            margin-left: ${theme.uptimeSpace[5]}px;
        }
        @keyframes cssAnimation{
            0%   {opacity: 1;}
            90%  {opacity: 1;}
            100% {opacity: 0;}
        }
        @-webkit-keyframes cssAnimation{
            0%   {opacity: 1;}
            90%  {opacity: 1;}
            100% {opacity: 0;}
        }
    `}
`;
